// KStatusFilter.tsx — Inhalt des Spaltenfilters „K-Status" (User 28.09.2026):
// dasselbe Popup wie an der Status-Pille der Akte (`KontaktstatusPopup`) —
// durchsuchbar, Hauptstatus Kunde | Interessent | Sonstige (im Filter seit
// 02.10.2026 beliebig kombinierbar) plus beliebig viele Rollen aus „Sonstige". Wert und Übersetzung ans Backend stehen in
// `kontaktstatusWahl.ts` (`kStatusFilterWert` / `kStatusFilterPayload`).

import * as React from "react";
import { useKontaktRollen } from "../../../services/useKontaktRollen";
import { KontaktstatusPopup } from "../KontaktstatusPopup";
import { kStatusFilterWert, kStatusWahlAusFilterWert, wahlBeschreibung } from "../kontaktstatusWahl";

export function KStatusFilter({
  value,
  onChange,
  close,
}: {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  close: () => void;
}) {
  // Filtern darf jede Rolle des Katalogs — auch CO-intern-Rollen: wer die
  // Kontakte nicht sehen darf, bekommt sie vom Backend ohnehin nicht.
  const katalog = useKontaktRollen();
  // Bewusst ohne Abhängigkeit vom Katalog: ein alter Bereichs-Wert
  // (`__bereich__:…`) wird beim Öffnen einmal aufgelöst.
  const start = React.useMemo(() => kStatusWahlAusFilterWert(value), [value]);
  return (
    <KontaktstatusPopup
      // Neu aufsetzen, sobald der Katalog des Mandanten geladen ist.
      key={katalog.length}
      modus="filter"
      start={start}
      bereiche={katalog}
      onAnwenden={(w) => {
        onChange(kStatusFilterWert(w));
        close();
      }}
      onZuruecksetzen={() => {
        onChange(undefined);
        close();
      }}
    />
  );
}

/**
 * K-Status im Filter-Blatt der Handy-Liste: dasselbe Popup wie am Desktop,
 * hinter einem Knopf, der die aktuelle Auswahl nennt. Aufgeklappt steht das
 * Popup direkt im Blatt — ein zweites schwebendes Fenster über dem Blatt
 * wäre auf 375 px nicht bedienbar.
 */
export function KStatusSheetFeld({
  value,
  onChange,
}: {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}) {
  const [offen, setOffen] = React.useState(false);
  const beschreibung = React.useMemo(() => wahlBeschreibung(kStatusWahlAusFilterWert(value)), [value]);
  return (
    <div className="ct-kst">
      <button
        type="button"
        className={"ct-kst-btn" + (beschreibung ? " aktiv" : "")}
        aria-expanded={offen}
        aria-label={`K-Status: ${beschreibung || "Alle"}`}
        onClick={() => setOffen((o) => !o)}
      >
        <span className="ct-kst-wert">{beschreibung || "Alle"}</span>
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M5 8l5 5 5-5" />
        </svg>
      </button>
      {offen ? (
        <div className="ct-kst-pop">
          <KStatusFilter value={value} onChange={onChange} close={() => setOffen(false)} />
        </div>
      ) : null}
    </div>
  );
}
